import { Grid, Typography } from "@mui/material";

import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import EditIcon from "../../../common/icons/editPencil.svg";

type Props = {
  reason: {
    editReason: string;
    editor: string;
    time: number;
  };
};

export const EditReasonBanner = ({ reason }: Props) => {
  const { t } = useTranslation(["order", "common"]);

  const date = reason.time ? new Date(reason.time) : new Date();
  // Use a localized label when available; fall back to the raw edit reason.
  const editReasonLabel = t(`editReasons.${reason.editReason}`, {
    defaultValue: reason.editReason,
  });
  // Use a localized editor label when available; fall back to the raw editor.
  const editorLabel = t(reason.editor, {
    ns: "common",
    defaultValue: reason.editor,
  });

  return (
    <Grid
      container
      item
      my={1}
      ml={2}
      xs={12}
      sx={{
        display: "flex",
        gap: "10px",
        backgroundColor: "#F1EDF7",
        padding: "8px",
        borderRadius: "4px",
      }}
    >
      <img src={EditIcon} alt={"editIcon"} style={{ marginRight: "5px" }} />
      <Typography fontWeight={600}>{t("editReason")}:</Typography>
      <Typography>{editReasonLabel}</Typography>
      <Typography variant="secondary">
        {"- "}
        {editorLabel} {format(date, "HH:mm, dd.MM.yyyy")}
      </Typography>
    </Grid>
  );
};
